module.exports = __webpack_public_path__ + "img/ios-icon-w.c5c1cf39.svg";